module.exports = __webpack_public_path__ + "static/img/huapo.ab5f92c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/huapo.png
// module id = BkIk
// module chunks = 1